import { FC, useContext, useMemo, useCallback } from 'react';
import { TaskAddEditContext } from '../../../../contexts/TaslAddEditFormContext';
import { FloatLabel } from 'primereact/floatlabel';
import { Calendar } from 'primereact/calendar';
import { TIME_VARIANTS } from '../FormConstants/FormConstants';

const DeadlineFormTab: FC = () => {
    const taskAddEditFormContext = useContext(TaskAddEditContext);

    const calendarContainerClass = useMemo(() => 
        `calendar--block__flex ${taskAddEditFormContext.datesError ? "input_with_error" : ""}`,
        [taskAddEditFormContext.datesError]
    );

    const showDatesError = useMemo(() => 
        Boolean(taskAddEditFormContext.datesError),
        [taskAddEditFormContext.datesError]
    );

    const handleTimeVariantClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        taskAddEditFormContext.selectTimeVariant(e);
    }, [taskAddEditFormContext.selectTimeVariant]);

    const handleCustomTimeChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        taskAddEditFormContext.onChangeCustomTime(e);
    }, [taskAddEditFormContext.onChangeCustomTime]);

    const renderTimeVariantButton = useCallback((item: number) => {
        const isSelected = item === taskAddEditFormContext.timeSelectVariant;
        const buttonClass = isSelected 
            ? "time-variants-container__chose" 
            : "time-variants-container__unchose";

        return (
            <button
                onClick={(e) => handleTimeVariantClick(e)}
                className={buttonClass}
                key={item}
                type="button"
            >
                {item}
            </button>
        );
    }, [taskAddEditFormContext.timeSelectVariant, handleTimeVariantClick]);

    return (
        <div className={`task__create--edit__form--tab__panel--type__task--all ${taskAddEditFormContext.forceLinkTerm && 'disabled'}`}>
            {taskAddEditFormContext.forceLinkTerm && <div className="text-editor-disabled-overlay"/>}
            {/* Дата выполнения задачи */}
            <div className="task__create--edit__form--tab__panel--type__task">
                Дата выполнения задачи
            </div>
            
            <div className={calendarContainerClass}>
                <div className="add-edit-deadlines-calendar">
                    <FloatLabel>
                        <Calendar 
                            dateFormat="dd.mm.yy" 
                            onChange={taskAddEditFormContext.onChangeStartDate} 
                            value={taskAddEditFormContext.startDate} 
                            inputId="start-date-input"
                        />
                        <label htmlFor="start-date-input">Дата начала</label>
                    </FloatLabel>
                </div>
                <div className="add-edit-deadlines-calendar">
                    <FloatLabel>
                        <Calendar 
                            dateFormat="dd.mm.yy" 
                            onChange={taskAddEditFormContext.onChangeEndDate} 
                            value={taskAddEditFormContext.endDate} 
                            inputId="end-date-input"
                        />
                        <label htmlFor="end-date-input">Дата окончания</label>
                    </FloatLabel>
                </div>
            </div>
            
            {showDatesError && (
                <p className="error_message" style={{ marginTop: "5px" }}>
                    {taskAddEditFormContext.datesError}
                </p>
            )}

            {/* Срок выполнения в часах */}
            <div className="task__create--edit__form--tab__panel--type__task">
                Срок выполнения в часах
            </div>
            
            <div className="time-variants-container">
                {TIME_VARIANTS.map(renderTimeVariantButton)}
            </div>

            {/* Свое время */}
            <div className="task__create--edit__form--tab__panel--type__task">
                Свое время
            </div>
            
            <div className="custom-time-container">
                <div className="custom-time-container--input">
                    <input
                        pattern="\d*"
                        value={taskAddEditFormContext.customHours}
                        onChange={handleCustomTimeChange}
                        type="text"
                        id="custom-hours-input"
                        className="custom-time-input"
                        inputMode="numeric"
                    />
                    <div className="custom-time-container--time__text">часы</div>
                </div>
                
                <div>
                    <div className="custom-time-container--pass">:</div>
                </div>
                
                <div className="custom-time-container--input">
                    <input
                        pattern="\d*"
                        value={taskAddEditFormContext.customMinutes}
                        onChange={handleCustomTimeChange}
                        type="text"
                        id="custom-minutes-input"
                        className="custom-time-input"
                        inputMode="numeric"
                    />
                    <div className="custom-time-container--time__text">минуты</div>
                </div>
            </div>
        </div>
    );
};

export default DeadlineFormTab;